import { ListResponseModel, QueryParamModel, SmOrderModel, SmOrderDetailsModel } from 'models';
import { EntityService } from 'utils/entityService';
import { TransferTaskFormProps } from 'pages/Ucse/UcseOrders/TransferTaskDialog';
import request, { Methods, requestFile } from 'utils/request';
import { exportFile } from 'utils/exportFile';
import { Mock } from 'utils/mockDecorator';
import { mockListResponse } from 'mock/list';

export interface DeleteQuery {
  id?: ID[];
}

class UcseOrderService extends EntityService {
  constructor() {
    super('ucse-order');
  }

  @Mock((params: QueryParamModel) =>
    import('mock/ucseOrders').then((m) => mockListResponse(m.MOCK_UCSE_ORDERS, params))
  )
  async getUcseOrderList(params?: QueryParamModel | null) {
    return request<ListResponseModel<SmOrderModel>>({
      method: Methods.GET,
      resource: this.resource,
      params,
    });
  }

  async getUcseOrderDetails(id: ID) {
    return request<SmOrderDetailsModel>({
      method: Methods.GET,
      resource: `${this.resource}/${id}`,
    });
  }

  async deleteUcseOrder(params: DeleteQuery) {
    return request({
      method: Methods.DELETE,
      resource: this.resource,
      params,
    });
  }

  async saveTransferTask(data: TransferTaskFormProps) {
    return request<ListResponseModel<SmOrderModel>>({
      method: Methods.POST,
      resource: 'task/transfer/ucse',
      data,
    });
  }

  async exportUcseOrders(params?: QueryParamModel | null) {
    const response = await requestFile<BlobPart>({
      method: Methods.GET,
      resource: `${this.resource}/export`,
      params,
    });

    exportFile(response);
    return response;
  }
}

export const ucseOrderService = new UcseOrderService();
